import React from 'react'
import Dock from 'react-dock'
import { Grid } from 'semantic-ui-react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'

const dockStyle = {
  background: '#1b1c1d',
  borderLeft: '1px solid #333',
  color: '#fff',
  boxShadow: '-2px 0px 10px 0px rgba(0,0,0,0.5)'
}

export class SideBar extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: window.innerWidth < 1024
    }
  }

  render() {
    return (
      <div className='sidebar'>
        <Dock
          position='right'
          isVisible={this.props.isDockOpen}
          size={this.state.isMobile ? 0.9 : 0.4}
          dockStyle={dockStyle}
        >
          {/* you can pass a function as a child here */}
          <div className='closer' onClick={() => this.props.toggleSideBar()}>
            <i className='icon x small red' />
          </div>
          <div
            className='dock-content'
            style={{ height: '100%' }}
            onClick={() => this.props.toggleSideBar()}
          >
            <h5>Diese Karten konnten gezogen werden</h5>

            <Grid relaxed columns={this.state.isMobile ? 2 : 4}>
              <Grid.Column>
                <img
                  src={require('../main/images/01.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/02.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/03.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/04.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/05.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/06.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/07.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/08.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/09.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/10.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>

              <Grid.Column>
                <img
                  src={require('../main/images/11.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/12.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/13.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/14.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/15.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/16.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/17.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/18.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/19.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/20.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/21.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/22.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/23.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/24.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/25.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/26.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/27.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/28.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/29.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/30.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/31.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/32.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/33.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/34.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/35.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/36.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/37.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
              <Grid.Column>
                <img
                  src={require('../main/images/38.svg')}
                  className='ui fluid image'
                />
              </Grid.Column>
            </Grid>
          </div>
        </Dock>
      </div>
    )
  }
}

export default SideBar
